import { 
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  ViewEncapsulation,
  AfterViewInit,
  Renderer2,
  ChangeDetectorRef,
  OnDestroy,
  ElementRef } from '@angular/core';
import { BdGraph } from 'src/lib/graph/graph.model';
import { ViewTreeNode } from 'src/app/engine/models/view.tree-node';
import { Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as _ from 'lodash';
import { TreeTheme } from '../tree/tree.component';

@Component({
  selector: 'app-tree-search',
  templateUrl: './tree-search.component.html',
  styleUrls: ['./tree-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TreeSearchComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input()
  public get query() {
    return this._query;
  }
  public set query(value) {
    this._query = value || '';
    
    if (this.query.length) {
      this.handleQueryChange();
    }
  }
  private _query = '';

  @Input()
  public get viewGraph(): BdGraph<ViewTreeNode> {
    return this._viewGraph;
  }
  public set viewGraph(value: BdGraph<ViewTreeNode>) {
    this._viewGraph = value;
    this.changeDetectorRef.markForCheck();
  }
  private _viewGraph: BdGraph<ViewTreeNode>;

  @Input()
  theme: TreeTheme = TreeTheme.Dark;

  searchResults: ViewTreeNode[] = [];
  searchHeight = 0;
  ngUnsubscribe = new Subject();

  constructor(
    private renderer: Renderer2,
    private changeDetectorRef: ChangeDetectorRef,
    private elementRef: ElementRef
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    // Window has resized, let the 3D canvas know
    this.renderer.listen('window', 'resize', (event) => {
      this.resize();
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  handleQueryChange() {
    this.searchResults = this.search(this.query);
    this.resize();
  }

  resize() {
    this.getSearchHeight()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((height) => {
        this.searchHeight = height;
        this.changeDetectorRef.markForCheck();
      });
  }

  getSearchHeight(): Observable<number> {
    const e = this.elementRef;

    return new Observable<number>((observer) => {
      setTimeout(() => {
        const offsetHeight = this.elementRef.nativeElement.offsetHeight;
  
        if (offsetHeight != null) {
          observer.next(offsetHeight);
          observer.complete();
        }
      });
    });
  }

  search(query: string): ViewTreeNode[] {
    query = query.toLowerCase();
    
    const results = Object.values(this.viewGraph.nodes)
      .filter((node: ViewTreeNode) => node.label.toLowerCase().indexOf(query) >= 0)
      .sort((a, b) => {
        return a.label.localeCompare(b.label);
      })
      .sort((a, b) => {
        return Math.sign(a.getDepth() - b.getDepth());
        
      });

    return results;
  }

  trackTreeNode(index: number, node: ViewTreeNode) { 
    return node.id; 
  }
  
}
